/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletHistoryCreateReqVo
 */
export interface UserWalletHistoryCreateReqVo {
    /**
     * 用户 ID，关联用户表主键，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    userId: number;
    /**
     * 钱包 ID，关联用户钱包表主键，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    walletId: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserWalletHistoryCreateReqVo
     */
    currencyCode: string;
    /**
     * 出入金额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    amount: number;
    /**
     * 出入金之后的钱包余额，必须大于等于 0，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    principal: number;
    /**
     * 出金入金类型：0-出金，1-入金，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    intOutType: number;
    /**
     * 备注说明，记录操作原因或说明信息，可选
     * @type {string}
     * @memberof UserWalletHistoryCreateReqVo
     */
    remark?: string;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    enable: number;
    /**
     * 
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    usedType?: number;
    /**
     * 
     * @type {number}
     * @memberof UserWalletHistoryCreateReqVo
     */
    usedId?: number;
}

/**
 * Check if a given object implements the UserWalletHistoryCreateReqVo interface.
 */
export function instanceOfUserWalletHistoryCreateReqVo(value: object): value is UserWalletHistoryCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('walletId' in value) || value['walletId'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('principal' in value) || value['principal'] === undefined) return false;
    if (!('intOutType' in value) || value['intOutType'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserWalletHistoryCreateReqVoFromJSON(json: any): UserWalletHistoryCreateReqVo {
    return UserWalletHistoryCreateReqVoFromJSONTyped(json, false);
}

export function UserWalletHistoryCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletHistoryCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'walletId': json['walletId'],
        'currencyCode': json['currencyCode'],
        'amount': json['amount'],
        'principal': json['principal'],
        'intOutType': json['intOutType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'enable': json['enable'],
        'usedType': json['usedType'] == null ? undefined : json['usedType'],
        'usedId': json['usedId'] == null ? undefined : json['usedId'],
    };
}

export function UserWalletHistoryCreateReqVoToJSON(json: any): UserWalletHistoryCreateReqVo {
    return UserWalletHistoryCreateReqVoToJSONTyped(json, false);
}

export function UserWalletHistoryCreateReqVoToJSONTyped(value?: UserWalletHistoryCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'walletId': value['walletId'],
        'currencyCode': value['currencyCode'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'remark': value['remark'],
        'enable': value['enable'],
        'usedType': value['usedType'],
        'usedId': value['usedId'],
    };
}

